module.exports = __webpack_public_path__ + "static/billsby-allowances-ca75b39d042866d5bd7ebb6cc2a1a482.svg";